export function nowLocalDateObject () {
    // Returns a local time Date object of the current time
    const now = new Date()
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
    return new Date(today)
}

export function dateObjectFromTimestamp (timestampStr) {
    // timestampStr format should be 'yyyy-mm-dd'
    // Returns a local time Date object
    let year = Number(timestampStr.slice(0, 4))
    let month = Number(timestampStr.slice(5, 7)) - 1
    let day = Number(timestampStr.slice(8, 10))
    return new Date(year, month, day)
}

export function datetimeObjectFromTimestamp (timestampStr) {
    // timestampStr format should be 'yyyy-mm-ddTHH:MM'
    // Returns a local time Date object
    let year = Number(timestampStr.slice(0, 4))
    let month = Number(timestampStr.slice(5, 7)) - 1
    let day = Number(timestampStr.slice(8, 10))
    let hour = Number(timestampStr.slice(11, 13))
    let mins = Number(timestampStr.slice(14, 16))
    return new Date(year, month, day, hour, mins)
}

export function getSpanishLocaleDateFormat (dateString) {
    // The expected return format is dd/mm/yyyy
    let dateObj = dateObjectFromTimestamp(dateString)
    try {
        return dateObj.toLocaleDateString('en-GB')
    } catch (error) {
        return dateObj.toLocaleDateString()
    }
}

export function getAssignmentClassByDate (assignmentDateString, serverTimeDateObj) {
    var assignmentDateObj = dateObjectFromTimestamp(assignmentDateString)
    assignmentDateObj.setHours(23, 55)
    // If the serverTime is later than the asignmentDate return a red text color class
    if (serverTimeDateObj > assignmentDateObj) {
        return 'text-danger'
    }
    // ...else return a green text colo class
    return 'text-success'
}

export function isSettingChecked (binaryString, currentUserEmailSettings) {
    let parsed = parseInt(binaryString, 2) & currentUserEmailSettings
    if (parsed > 0) {
        return 1
    }
    return 0
}

export function getFormattedHour (militaryHour) {
    const formattedHours = [
        '12:00 am', '1:00 am', '2:00 am', '3:00 am', '4:00 am', '5:00 am',
        '6:00 am', '7:00 am', '8:00 am', '9:00 am', '10:00 am', '11:00 am',
        '12:00 pm', '1:00 pm', '2:00 pm', '3:00 pm', '4:00 pm', '5:00 pm',
        '6:00 pm', '7:00 pm', '8:00 pm', '9:00 pm', '10:00 pm', '11:00 pm'
    ]
    return formattedHours[militaryHour]
}
